"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Popover;
var _regeneratorRuntime2 = _interopRequireDefault(require("@babel/runtime/helpers/regeneratorRuntime"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread2"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _core = require("@popperjs/core");
var _context4 = _interopRequireDefault(require("../Theme/context"));
var _context5 = require("./context");
var _ModalBase = _interopRequireDefault(require("./ModalBase"));
var _excluded = ["classNames", "AnchorComponent", "AnchorComponentProps", "getAnchorElement", "popperOptions", "effect", "children", "ComponentProps", "ContentComponentProps", "beforeOpen", "onOpen", "beforeClose", "onClose"];
var defaultStyle = require("./../empty_css.js")["default"];
function Popover(props) {
  var themeContext = (0, _react.useContext)(_context4["default"]);
  var _themeContext$additio = themeContext.additionalStyles,
    additionalStyles = _themeContext$additio === void 0 ? {} : _themeContext$additio,
    useStyle = themeContext.useStyle;
  var _props$classNames = props.classNames,
    classNames = _props$classNames === void 0 ? additionalStyles.modal || defaultStyle : _props$classNames,
    _props$AnchorComponen = props.AnchorComponent,
    AnchorComponent = _props$AnchorComponen === void 0 ? 'div' : _props$AnchorComponen,
    _props$AnchorComponen2 = props.AnchorComponentProps,
    AnchorComponentProps = _props$AnchorComponen2 === void 0 ? {} : _props$AnchorComponen2,
    getAnchorElement = props.getAnchorElement,
    popperOptions = props.popperOptions,
    effect = props.effect,
    children = props.children,
    _props$ComponentProps = props.ComponentProps,
    ComponentProps = _props$ComponentProps === void 0 ? {} : _props$ComponentProps,
    _props$ContentCompone = props.ContentComponentProps,
    ContentComponentProps = _props$ContentCompone === void 0 ? {} : _props$ContentCompone,
    beforeOpen = props.beforeOpen,
    onOpen = props.onOpen,
    beforeClose = props.beforeClose,
    onClose = props.onClose,
    rest = (0, _objectWithoutProperties2["default"])(props, _excluded);
  if (classNames !== additionalStyles.modal) {
    if (typeof useStyle === 'function') {
      useStyle(classNames);
    }
  }
  var anchor = (0, _react.useRef)();
  var _modal = (0, _react.useRef)();
  var modal = (0, _react.useRef)();
  var popper = (0, _react.useRef)();
  var content = (0, _react.useRef)();
  function initPopper() {
    var anchorElement = getAnchorElement ? getAnchorElement() : null;
    var modifiers = (popperOptions === null || popperOptions === void 0 ? void 0 : popperOptions.modifiers) || [];
    var preventOverflow = modifiers.find(function (m) {
      return m.name === 'preventOverflow';
    });
    var pO = (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, popperOptions ? popperOptions : {}), {}, {
      modifiers: [].concat((0, _toConsumableArray2["default"])(modifiers.filter(function (m) {
        return m.name !== 'preventOverflow';
      })), [(0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, preventOverflow ? preventOverflow : {}), {}, {
        name: 'preventOverflow',
        options: (0, _objectSpread2["default"])({
          mainAxis: true,
          altAxis: true,
          padding: {
            left: 16,
            right: 16,
            top: 0,
            bottom: 0
          },
          altBoundary: true,
          tether: false,
          tetherOffset: 0,
          boundary: _modal.current ? [_modal.current] : 'clippingParents',
          rootBoundary: _modal.current ? [_modal.current] : 'parent'
        }, preventOverflow !== null && preventOverflow !== void 0 && preventOverflow.options ? preventOverflow.options : {})
      })])
    });
    if (anchorElement && content.current) {
      popper.actions = (0, _core.createPopper)(anchorElement, content.current, pO);
    } else if (anchor.current && content.current) {
      popper.actions = (0, _core.createPopper)(anchor.current, content.current, pO);
    } else {
      popper.actions = null;
    }
  }
  function updateModal() {
    modal.current = _modal.current;
    modal.actions = (0, _objectSpread2["default"])((0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, _modal.actions ? _modal.actions : {}), _modal.actions.setOpen ? {
      setOpen: function () {
        var _setOpen = (0, _asyncToGenerator2["default"])(/*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee(value) {
          var br;
          return (0, _regeneratorRuntime2["default"])().wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                br = false;
                if (!value) {
                  _context.next = 8;
                  break;
                }
                if (!beforeOpen) {
                  _context.next = 6;
                  break;
                }
                _context.next = 5;
                return beforeOpen();
              case 5:
                br = _context.sent;
              case 6:
                _context.next = 12;
                break;
              case 8:
                if (!beforeClose) {
                  _context.next = 12;
                  break;
                }
                _context.next = 11;
                return beforeClose();
              case 11:
                br = _context.sent;
              case 12:
                if (!br) {
                  _context.next = 14;
                  break;
                }
                return _context.abrupt("return");
              case 14:
                _context.next = 16;
                return _modal.actions.setOpen(value);
              case 16:
                initPopper();
                if (!value) {
                  _context.next = 22;
                  break;
                }
                _context.next = 20;
                return updatePopper();
              case 20:
                _context.next = 22;
                return updatePopper();
              case 22:
                if (!value) {
                  _context.next = 28;
                  break;
                }
                if (!onOpen) {
                  _context.next = 26;
                  break;
                }
                _context.next = 26;
                return onOpen();
              case 26:
                _context.next = 31;
                break;
              case 28:
                if (!onClose) {
                  _context.next = 31;
                  break;
                }
                _context.next = 31;
                return onClose();
              case 31:
              case "end":
                return _context.stop();
            }
          }, _callee);
        }));
        function setOpen(_x) {
          return _setOpen.apply(this, arguments);
        }
        return setOpen;
      }()
    } : {}), _modal.actions.toggleOpen ? {
      toggleOpen: function () {
        var _toggleOpen = (0, _asyncToGenerator2["default"])(/*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee2() {
          var openBeforeToggle, br, open;
          return (0, _regeneratorRuntime2["default"])().wrap(function _callee2$(_context2) {
            while (1) switch (_context2.prev = _context2.next) {
              case 0:
                if (!_modal.actions.getOpen) {
                  _context2.next = 16;
                  break;
                }
                openBeforeToggle = _modal.actions.getOpen();
                br = false;
                if (openBeforeToggle) {
                  _context2.next = 10;
                  break;
                }
                if (!beforeOpen) {
                  _context2.next = 8;
                  break;
                }
                _context2.next = 7;
                return beforeOpen();
              case 7:
                br = _context2.sent;
              case 8:
                _context2.next = 14;
                break;
              case 10:
                if (!beforeClose) {
                  _context2.next = 14;
                  break;
                }
                _context2.next = 13;
                return beforeClose();
              case 13:
                br = _context2.sent;
              case 14:
                if (!br) {
                  _context2.next = 16;
                  break;
                }
                return _context2.abrupt("return");
              case 16:
                _context2.next = 18;
                return _modal.actions.toggleOpen();
              case 18:
                open = _context2.sent;
                if (!open) {
                  _context2.next = 25;
                  break;
                }
                initPopper();
                _context2.next = 23;
                return updatePopper();
              case 23:
                _context2.next = 25;
                return updatePopper();
              case 25:
                if (!open) {
                  _context2.next = 31;
                  break;
                }
                if (!onOpen) {
                  _context2.next = 29;
                  break;
                }
                _context2.next = 29;
                return onOpen();
              case 29:
                _context2.next = 34;
                break;
              case 31:
                if (!onClose) {
                  _context2.next = 34;
                  break;
                }
                _context2.next = 34;
                return onClose();
              case 34:
                return _context2.abrupt("return", open);
              case 35:
              case "end":
                return _context2.stop();
            }
          }, _callee2);
        }));
        function toggleOpen() {
          return _toggleOpen.apply(this, arguments);
        }
        return toggleOpen;
      }()
    } : {});
  }
  function updatePopper() {
    return _updatePopper.apply(this, arguments);
  }
  function _updatePopper() {
    _updatePopper = (0, _asyncToGenerator2["default"])(/*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee3() {
      return (0, _regeneratorRuntime2["default"])().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            if (!popper.actions) {
              _context3.next = 4;
              break;
            }
            popper.actions.update();
            _context3.next = 6;
            break;
          case 4:
            _context3.next = 6;
            return new Promise(function (resolve) {
              var _int = setInterval(function () {
                if (popper.actions) {
                  clearInterval(_int);
                  clearTimeout(to);
                  resolve();
                  popper.actions.update();
                } else {
                  initPopper();
                }
              }, 1);
              var to = setTimeout(function () {
                if (_int) {
                  clearInterval(_int);
                  clearTimeout(to);
                  resolve();
                }
              }, 1000);
            });
          case 6:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return _updatePopper.apply(this, arguments);
  }
  var anchorEl = getAnchorElement ? getAnchorElement() : anchor.current;
  (0, _react.useEffect)(function () {
    initPopper();
  }, [anchorEl, _modal.current]);
  (0, _react.useEffect)(function () {
    if (effect) {
      updateModal();
      effect({
        popper: popper,
        modal: modal,
        anchor: anchor,
        content: content
      });
    }
    return function () {
      if (effect) {
        effect({
          popper: {},
          modal: {},
          anchor: {},
          content: {}
        });
      }
    };
  });
  return /*#__PURE__*/_react["default"].createElement(_context5.PopoverContext.Provider, {
    value: {
      popper: popper,
      anchor: anchor,
      modal: modal,
      content: content
    }
  }, AnchorComponent ? /*#__PURE__*/_react["default"].createElement(AnchorComponent, Object.assign({}, AnchorComponentProps, {
    ref: function ref(e) {
      anchor.current = e;
      if (AnchorComponentProps.ref) {
        if (typeof AnchorComponentProps.ref === 'function') {
          AnchorComponentProps.ref(e);
        } else if (AnchorComponentProps.ref && typeof AnchorComponentProps.ref === 'object') {
          AnchorComponentProps.ref.current = e;
        }
      }
    }
  })) : null, /*#__PURE__*/_react["default"].createElement(_ModalBase["default"], Object.assign({
    classNames: classNames,
    ComponentProps: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, ComponentProps), {}, {
      ref: function ref(e) {
        _modal.current = e;
        updateModal();
        if (ComponentProps.ref) {
          if (typeof ComponentProps.ref === 'function') {
            ComponentProps.ref(e);
          } else if (ComponentProps.ref && typeof ComponentProps.ref === 'object') {
            ComponentProps.ref.current = e;
          }
        }
      }
    }),
    ContentComponentProps: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({
      'container-type': 'root-root root-page'
    }, ContentComponentProps), {}, {
      ref: function ref(e) {
        content.current = e;
        if (ContentComponentProps.ref) {
          if (typeof ContentComponentProps.ref === 'function') {
            ContentComponentProps.ref(e);
          } else if (ContentComponentProps.ref && typeof ContentComponentProps.ref === 'object') {
            ContentComponentProps.ref.current = e;
          }
        }
      }
    }),
    effect: function effect(_ref) {
      var actions = _ref.actions;
      _modal.actions = actions;
      updateModal();
      initPopper();
    }
  }, rest), children));
}